import * as React from 'react';

const buyerIntentSignalSmall = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 5C0 2.23858 2.23858 0 5 0H15C17.7614 0 20 2.23858 20 5V15C20 17.7614 17.7614 20 15 20H5C2.23858 20 0 17.7614 0 15V5Z"
      fill="white"
    />
    <circle
      cx="5.86207"
      cy="4.86207"
      r="3.86207"
      fill="url(#paint0_linear_23086_12751)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9994 12.7946C17.982 11.7204 17.5476 10.6952 16.7879 9.93558C16.0119 9.15958 14.9594 8.72363 13.862 8.72363C12.7645 8.72363 11.7121 9.15958 10.9361 9.93558C10.1601 10.7116 9.72412 11.7641 9.72412 12.8615C9.72412 13.9589 10.1601 15.0114 10.9361 15.7874L12.8873 17.7381L12.9535 17.8002C13.2168 18.0307 13.5578 18.1526 13.9076 18.1411C14.2573 18.1295 14.5896 17.9855 14.8371 17.7381L16.7879 15.7879L16.8812 15.6913C17.6159 14.9075 18.0169 13.8687 17.9994 12.7946ZM13.862 13.7816C14.6237 13.7816 15.2413 13.1641 15.2413 12.4024C15.2413 11.6406 14.6237 11.0231 13.862 11.0231C13.1002 11.0231 12.4827 11.6406 12.4827 12.4024C12.4827 13.1641 13.1002 13.7816 13.862 13.7816Z"
      fill="url(#paint1_linear_23086_12751)"
    />
    <g style={{ mixBlendMode: 'multiply' }}>
      <circle
        cx="9.56661"
        cy="9.67013"
        r="5.91134"
        fill="url(#paint2_linear_23086_12751)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_23086_12751"
        x1="8.50831"
        y1="7.47466"
        x2="-1.05149"
        y2="3.93446"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2744FF" />
        <stop offset="1" stopColor="#B9D5FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_23086_12751"
        x1="16.6973"
        y1="16.6183"
        x2="6.16524"
        y2="13.1911"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2744FF" />
        <stop offset="1" stopColor="#B9D5FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_23086_12751"
        x1="9.56661"
        y1="3.75879"
        x2="11.3855"
        y2="17.8551"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7DC4FF" />
        <stop offset="1" stopColor="#FFE7AB" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default buyerIntentSignalSmall;
